import React from "react";
import { LogicalOperatorEnumerator } from "./LogicalOperatorsOptions";

/**
 * Only display a message regarding filtering null or empty values (objections to it)
 * @param {*} props
 */
class LogicalOperatorHasValueView extends React.PureComponent {
  onApplyFilter = () => {
    this.props.onApplyFilter && this.props.onApplyFilter({});
  };

  render() {
    const objection =
      this.props.choosed.option === LogicalOperatorEnumerator.HasValue && "not";
    return (
      <>
        <div className="p-2">
          <div className="filter-select-min-label-height">
            Filter for {objection} null or {objection} empty results.
          </div>
        </div>
      </>
    );
  }
}

export default LogicalOperatorHasValueView;
